import { PAGE_CODES } from 'constants/pageCodes';

export const PostClosingOptionListType = {
  MIN_DEACTIVATION_TYPE: PAGE_CODES.MIN_DEACTIVATION_TYPES,
  UNSALABLE_RESPONSIBLE_PARTY: PAGE_CODES.UNSALABLE_RESPONSIBLE_PARTIES,
  UNSALABLE_REASON: PAGE_CODES.UNSALABLE_REASONS,
};

export const POST_CLOSING_OPTION_LIST_TYPES = Object.values(PostClosingOptionListType);

export const POST_CLOSING_OPTION_ROUTE_BASE = {
  [PostClosingOptionListType.MIN_DEACTIVATION_TYPE]: '/min-deactivation-types',
  [PostClosingOptionListType.UNSALABLE_RESPONSIBLE_PARTY]: '/unsalable-responsible-parties',
  [PostClosingOptionListType.UNSALABLE_REASON]: '/unsalable-reasons',
};

export const POST_CLOSING_OPTION_LIST_TITLE = {
  [PostClosingOptionListType.MIN_DEACTIVATION_TYPE]: 'MIN Deactivation Types',
  [PostClosingOptionListType.UNSALABLE_RESPONSIBLE_PARTY]: 'Unsalable Responsible Parties',
  [PostClosingOptionListType.UNSALABLE_REASON]: 'Unsalable Reasons',
};
